import {IProfileUpdate, IUpdateBankDetails, IVerifyProfile} from '../../types'
import { getCertificateReferenceId } from '../../app/modules/profile-management/certificate-helpers'

export const ProfileJson = {
  UpdateProfile: ({business, pendingCertificates, code}: IProfileUpdate) => {
    const form = new FormData();

    /** ================= BASIC DETAILS ================= */
    // if (code && code !== '') {
    //   form.append('code', code)
      form.append('phone', business.phone)
      form.append('phoneCountry', business.phoneCountry)
      form.append('email', business.email)
    // }
    form.append("ownerName", business.ownerName);
    form.append("name", business.name);
    form.append("about", business.about || "");
    form.append("lat", String(business.lat));
    form.append("lng", String(business.lng));
    /** ================= BUSINESS DETAILS ================= */
    form.append("tinNumber", business.tinNumber || "");
    form.append("vatNumber", business.vatNumber || "");
    form.append("legalName", business.legalName || "");
    form.append("tradeName", business.tradeName || "");

    /** ================= ADDRESS ================= */
    // form.append("address", business.address || "");
    form.append(
      "address[addressLine1]",
      business.addressDetails?.addressLine1 || ""
    );
    form.append("address[city]", business.addressDetails?.city || "");
    form.append("address[state]", business.addressDetails?.state || "");
    form.append(
      "address[countryName]",
      business.addressDetails?.countryName || ""
    );
    form.append(
      "address[postalCode]",
      business.addressDetails?.postalCode || ""
    );

    /** ================= IMAGE ================= */
    if (business.imageReader && business.imageReader !== "") {
      form.append("image", business.imageReader);
    }
    if (business.removeImage) {
      form.append("removeImage", "true");
    }

    /** ================= CATEGORIES ================= */
    if (business.categories?.length) {
      business.categories.forEach((catVal: any, index: number) => {
        const categoryId =
          catVal?.reference?._id ??
          catVal?.reference ??
          catVal?._id
        if (categoryId) {
          form.append(`categories[${index}]`, String(categoryId));
        }
      });
    }

    /** ================= PAYMENT DETAILS ================= */
    form.append("paymentTerms", String(business.paymentTerms || ""));
    form.append("paymentMode", String(business.paymentMode || ""));
    form.append("creditLimit", String(business.creditLimit || ""));
    form.append("leadDuration", String(business.leadDuration || ""));
    form.append("currency", business.currency || "");

    /** ================= WORKING DAYS ================= */
    if (business.workingDays && Array.isArray(business.workingDays)) {
      business.workingDays.forEach((day: number, index: number) => {
        form.append(`workingDays[${index}]`, String(day));
      });
    }

    /** ================= TAX DETAILS ================= */
    if (business.taxDetails) {
      form.append("taxDetails[type]", String(business.taxDetails.type || ""));
      form.append("taxDetails[number]", business.taxDetails.number || "");
    }

    /** ================= CONTRACT DETAILS ================= */
    form.append(
      "hasAnnualContract",
      String(business.hasAnnualContract || false)
    );
    form.append("contractValidFrom", business.contractValidFrom || "");
    form.append("contractValidTo", business.contractValidTo || "");

    /** ================= CERTIFICATES (ONLY CHANGED) ================= */
    if (business.certificates?.length) {
      const changedCertificates = business.certificates.filter(
        (c: any) => c.isChanged === true || c.isAdded === true || Boolean(c.imageReader)
      );

      if (changedCertificates.length) {
        let uploadIndex = 0
        changedCertificates.forEach((val: any) => {
          const referenceId = getCertificateReferenceId(val)
          if (!referenceId) return

          form.append(`certificates[${uploadIndex}][reference]`, referenceId);
          form.append(`certificates[${uploadIndex}][expiry]`, val.expiry || "");

          if (val.imageReader) {
            form.append(`certificates[${uploadIndex}][file]`, val.imageReader);
            form.append(`certificates[${uploadIndex}][removeFile]`, "false");
          } else {
            form.append(`certificates[${uploadIndex}][removeFile]`, "false");
          }
          uploadIndex += 1
        });
      }
    }

    /** ================= BUSINESS TYPES ================= */
    if (business.types?.length) {
      business.types.forEach((businessVal: any, index: number) => {
        form.append(`types[${index}]`, businessVal.reference._id);
      });
    }

    /** ================= BANKS ================= */
    if (business.banks?.length) {
      business.banks.forEach((bank: any, index: number) => {
        if (bank.tigoNumber) {
          form.append(`banks[${index}][tigoNumber]`, bank.tigoNumber);
        }

        if (bank.bankName) {
          form.append(`banks[${index}][bankName]`, bank.bankName);
        }

        if (bank.branchName) {
          form.append(`banks[${index}][branchName]`, bank.branchName);
        }

        if (bank.accountNumber) {
          form.append(`banks[${index}][accountNumber]`, bank.accountNumber);
        }

        if (bank.bankType) {
          form.append(`banks[${index}][bankType]`, bank.bankType);
        }
        if (bank._id) {
          form.append(`banks[${index}][_id]`, bank._id);
        }
      });
    }
    return form
  },
  VerifyDetails: ({email, phone, phoneCountry}: IVerifyProfile) => {
    if (email) {
      return {email: email}
    }
    if (phone && phoneCountry) {
      return {phone: phone, phoneCountry: phoneCountry}
    }
  },
  UpdateBankDetails: ({
    bankName,
    branch,
    accountNumber,
    tigoNumber,
    identifierCode,
  }: IUpdateBankDetails) => {
    return {
      bankName: bankName,
      branch: branch,
      accountNumber: accountNumber,
      tigoNumber: tigoNumber,
      identifierCode: identifierCode,
    }
  },
}
